import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { AuthenticationService, SnackbarService } from '@app/services';
import { ExternalAuthConfig, OidcProvider } from '@app/models/authentification-config';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';



@Component({
  selector: 'app-open-id-form',
  templateUrl: './open-id-connect-form.component.html',
  styleUrls: ['./open-id-connect-form.component.scss'],
  standalone: false
})
export class OpenIdFormComponent implements OnInit, OnDestroy {

  providers: OidcProvider[];

  @Input() from: 'login' | 'register';

  @Output() redirecting = new EventEmitter();
  @Output() redirectingMessage = new EventEmitter();

  destroy$ = new Subject<void>();

  constructor(
    private authService: AuthenticationService,
    private snackbarService: SnackbarService
  ) {
  }

  ngOnInit(): void {
    this.authService.getExternalAuthConf().pipe(takeUntil(this.destroy$))
      .subscribe((conf: ExternalAuthConfig) => {
        this.providers = conf.providers.filter(p => p.isActive)
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openIdConnect(providerId: string) {
    this.redirecting.emit(true);
    this.redirectingMessage.emit('redirecting_to_oidc');

    this.authService.openIdConnectInitLogin(providerId, this.from).subscribe({
      next: result => {
        if (result.redirectTo) {
          window.location.href = result.redirectTo;
        } else {
          this.redirecting.emit(false);
          this.snackbarService.error(`Erreur, la requête n'a pas renvoyé l'url de redirection`);
          console.error(`Erreur, la requête n'a pas renvoyé l'url de redirection : `, result)
        }

      }
      , error: error => {
        console.log('suis je ici ? ', error)

        this.redirecting.emit(false);
        this.authService.setOidcMessage({ type: 'error', message: error })
      }
    })
  }

}
